/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from 'modules/auth/hooks/auth'
import { Fragment, FunctionComponent, useEffect, useState } from 'react'
import {
  MdLocalOffer,
  MdPerson,
  MdLocalShipping,
  MdCreditCard,
  MdPhone,
  MdInsertDriveFile,
  MdKeyboardArrowRight,
  MdArrowDropDown,
} from 'react-icons/md'

import { FaRoad } from 'react-icons/fa'

import { useHistory, useLocation } from 'react-router-dom'
import userProfile from 'shared/config/userProfile'

import { version } from '../../../../package.json'

import CaminhaoRoutes from '../../../modules/caminhao/utils/CaminhaoRoutes'
import PagamentosRoutes from '../../../modules/pagamentos/utils/PagamentoRoutes'
import VeiculoRoutes from '../../../modules/veiculos/utils/VeiculoRoutes'
import IconVeiculo from '../Icons/IconVeiculo'
import {
  Container,
  MenuItem,
  Menu,
  MenuIcon,
  MenuTitle,
  MenuWrapper,
  Line,
  BottomText,
} from './styles'

interface IMenuSubItemsProps {
  title: string
  path: string
}

interface IMenuItemsProps {
  title: string
  icon: any
  subItems?: Array<IMenuSubItemsProps>
  path?: string
  divider?: boolean
  scope: string[]
}

const menuItems: IMenuItemsProps[] = [
  {
    title: 'Ofertas de cargas',
    icon: <MdLocalOffer />,
    subItems: [
      {
        title: 'Ver cargas',
        path: '/lotes',
      },
      {
        title: 'Cargas solicitadas',
        path: '/lotes-solicitados',
      },
    ],
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Motoristas',
    icon: <MdPerson />,
    subItems: [
      {
        title: 'Lista de motoristas',
        path: '/motoristas',
      },
      {
        title: 'Adicionar motorista',
        path: '/motoristas/new',
      },
    ],
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Veículos',
    icon: <IconVeiculo size={10} />,
    subItems: [
      {
        title: 'Lista de veículos',
        path: VeiculoRoutes.LIST,
      },
      {
        title: 'Adicionar veículos',
        path: VeiculoRoutes.CREATE,
      },
    ],
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Caminhões',
    icon: <MdLocalShipping />,
    subItems: [
      {
        title: 'Lista de caminhões',
        path: CaminhaoRoutes.LIST,
      },
      {
        title: 'Adicionar caminhão',
        path: CaminhaoRoutes.CREATE,
      },
    ],
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Pagamento',
    icon: <MdCreditCard />,
    path: PagamentosRoutes.PAGAMENTO,
    scope: [userProfile.status.master, userProfile.status.admin],
  },
  {
    title: 'Fale conosco',
    icon: <MdPhone />,
    path: '/fale-conosco',
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Vale pedágio',
    icon: <FaRoad />,
    path: '/vale-pedagio',
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
  {
    title: 'Termos de Uso',
    icon: <MdInsertDriveFile />,
    path: '/termos-uso',
    divider: true,
    scope: [
      userProfile.status.master,
      userProfile.status.admin,
      userProfile.status.operacional,
    ],
  },
]

const Sidebar: FunctionComponent = () => {
  const [openMenu, setOpenMenu] = useState(false)
  const [selected, setSelected] = useState(null)
  const [selectedSubItem, setSelectedSubItem] = useState(null)
  const { perfil } = useAuth()
  const [availableMenu] = useState(() => {
    return menuItems.filter(menuItem => menuItem.scope.includes(perfil))
  })
  const history = useHistory()
  const { pathname } = useLocation()

  useEffect(() => {
    const findMenu = menuItems.findIndex(menuItem => {
      return menuItem.path === pathname
    })

    if (findMenu === -1) {
      setOpenMenu(false)
      const findSubMenu = menuItems.find(menuItem => {
        return menuItem.subItems?.find(subMenu => subMenu.path === pathname)
      })

      if (findSubMenu && findSubMenu.title) {
        const indexMenu = menuItems.indexOf(findSubMenu)
        const indexSubMenu = menuItems[indexMenu].subItems.findIndex(
          subMenu => subMenu.path === pathname,
        )
        setOpenMenu(true)
        setSelected(indexMenu)
        setSelectedSubItem(indexSubMenu)
      }
    }
  }, [pathname])

  const handleOpenMenu = (menu: IMenuItemsProps, index: number) => {
    setSelectedSubItem(null)
    setSelected(index)

    if (!menu.subItems) history.push(menu.path)
    else setOpenMenu(true)
  }
  return (
    <Container>
      <Menu>
        {availableMenu.map((item, index) => (
          <Fragment key={index}>
            {item.divider && <Line />}

            <MenuItem
              selected={selectedSubItem === null && selected === index}
              key={index}
              onClick={() => handleOpenMenu(item, index)}
            >
              <MenuWrapper>
                <MenuIcon style={{ fontSize: '10px' }}>{item?.icon}</MenuIcon>
                <MenuTitle>{item?.title}</MenuTitle>
              </MenuWrapper>
              {item?.subItems && !!item?.subItems.length && (
                <MenuIcon>
                  <MdArrowDropDown size={24} />
                </MenuIcon>
              )}
            </MenuItem>
            {item?.subItems &&
              !!item?.subItems.length &&
              openMenu &&
              selected === index &&
              item?.subItems.map((subItem, key) => (
                <MenuItem
                  key={key}
                  onClick={() => {
                    setSelectedSubItem(key)

                    history.push(subItem.path)
                  }}
                  selected={selectedSubItem === key}
                >
                  <MenuWrapper>
                    <MenuIcon>
                      <MdKeyboardArrowRight size={24} />
                    </MenuIcon>
                    <MenuTitle>{subItem?.title}</MenuTitle>
                  </MenuWrapper>
                </MenuItem>
              ))}
          </Fragment>
        ))}
      </Menu>

      <BottomText>Versão {version}</BottomText>
    </Container>
  )
}

export default Sidebar
